var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'page page-' + _vm.slug + ' background-'},[_c('RenderBlocks',{attrs:{"blocks":_vm.data.blocks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }